import React, { lazy, Suspense } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  createBrowserRouter,
  Navigate,
  Outlet,
} from "react-router-dom";
import { useSelector } from "react-redux";

// Loader
import FullPageLoading from "./components/FullPageLoading/FullPageLoading";

// Layout
import Layout from "./hocs/Layout";

// Authentication pages
import AuthPage from "./containers/AuthPage/AuthPage";

// Container Imports
// const HomePage = lazy(() => import("./containers/Home/HomePage"));
const NotFound = lazy(() => import("./containers/NotFound/NotFound"));

// Styles Imports
import "./App.css";
import "./containers/global.css";
import ModelsPage from "./containers/Models/ModelsPage";
import ProductReview from "./containers/ProductReview/ProductReview";
import ProductListing from "./containers/ProductListingPage/ProductListing";
import ProductDetail from "./containers/ProductDetailPage/ProductDetail";
import Preview from "./containers/BulkUpload/BulkUpload";
import ModelDetailPage from "./containers/ModelDetailPage/ModelDetailPage";
import MapBodyType from "./containers/MapBodyType/MapBodyType";
import Dashboard from "./containers/Dashboard/Dashboard";
import CreateModel from "./containers/CreateModel/CreateModel";
import VariantDetail from "./containers/VariantDetailPage/VariantDetailPage";

import PrivateRoute from "./components/PrivateRoute/PrivateRoute";
import SelectStore from "./containers/SelectStore/SelectStore";

const LayoutWrapper = () => (
  <Layout>
    <Suspense fallback={<FullPageLoading />}>
      <Outlet />
    </Suspense>
  </Layout>
);

const router = createBrowserRouter([
  {
    path: "/login",
    element: <AuthPage />,
  },
  {
    path: "/",
    element: <LayoutWrapper />,
    children: [
      {
        element: <PrivateRoute />,
        children: [
          { path: "/", element: <Navigate to="/" replace /> },
          {
            path: "/modelsandbox",
            element: <ModelsPage />,
          },
          {
            path: "/modelDetail/:id",
            element: <ModelDetailPage />,
          },
          {
            path: "/model/:id",
            element: <CreateModel />,
          },
          {
            path: "/model/add",
            element: <CreateModel />,
          },
          {
            path: "/unusedimages",
            element: <ProductReview />,
          },
          {
            path: "/mapbodytype",
            element: <MapBodyType />,
          },
          {
            path: "/stores",
            element: <Dashboard />,
          },
          {
            path: "/product/:id",
            element: <ProductDetail />,
          },
          {
            path: "/variant/:id",
            element: <VariantDetail />,
          },
          {
            path: "/productsandbox",
            element: <ProductListing />,
          },
          {
            path: "/bulkupload",
            element: <Preview />,
          },
        ],
      },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
  {
    path: "/selectstore",
    element: <SelectStore />,
  },
]);
export default router;
